module.exports = __webpack_public_path__ + "static/img/nwxy.6c7150aa.png";